module.exports = __webpack_public_path__ + "files/f82b2a4484ac5c54e743d1bb1dc999e4.png";